import { useState } from "react"

import "../css/Portal.css";

import Sidebar from "../components/Sidebar";

import Tickets from "./Tickets";

const Portal = ({pageName}) => {
    const [page, setPage] = useState(pageName);

    return <div className="content">
        <Sidebar/>

        <div className="vertical-content">
            <div className="page">
                {pageName == "Tickets" && <Tickets ticketStatus="Active"/>}
                {pageName == "Archive" && <Tickets ticketStatus="Archived"/>}
            </div>
        </div>
    </div>
}

export default Portal;